import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';

interface CheckboxFilterMenuItemProps {
  checked?: boolean;
  highlighted?: boolean;
  id?: string;
  label: string;
  onClick: (event: React.MouseEvent) => void;
  onMouseEnter?: (event: React.MouseEvent) => void;
}

export default function CheckboxFilterMenuItem({
  checked,
  highlighted,
  id,
  label,
  onClick,
  onMouseEnter,
}: CheckboxFilterMenuItemProps) {
  const theme = useTheme();

  return (
    <MenuItem
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      id={id}
      selected={highlighted}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          gap: 1,
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Tooltip title={label} placement="right" disableInteractive>
          <FormControlLabel
            label={label}
            control={
              <Checkbox
                checked={Boolean(checked)}
                size="small"
                sx={{
                  '&.MuiCheckbox-root': {
                    py: 0,
                    color: theme.brandV2.colors.treadGray6,
                  },
                  '&.Mui-checked': { color: theme.brandV2.colors.treadOrange },
                }}
              />
            }
            sx={{
              '&.MuiFormControlLabel-root': {
                mr: 0,
                overflow: 'hidden',
                width: '100%',
                '& .MuiFormControlLabel-label': {
                  color: theme.brandV2.colors.treadBlack,
                  fontSize: '12px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  width: '100%',
                },
              },
            }}
          />
        </Tooltip>
      </Box>
    </MenuItem>
  );
}
